<template>
    <div>
        <div class="card dashcard mb-3">
            <div class="card-body">
                <div class="row">
                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Selecione Profissional..."
                            icon2="fas fa-user-md fa-fw" 
                            type="select" 
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            :optionsParm="{ ativos: true }"
                            v-model="medico">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="buscar_apuracao()">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Baseado na Regra de Rateio"
                            icon="far fa-calendar-alt fa-fw" 
                            type="select" 
                            :optionsList="[
                                { id: 'P', search: 'Baseado na Produção' },
                            ]"
                            optionsData="id"
                            v-model="origem" />
                    </div>
                    <div class="col col-12 col-md-4 d-flex flex-column">
                        <button type="button" class="btn btn-outline-primary" @click="verificar_atendimentos()">
                            Verificar Atendimentos 
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress" v-if="apurando_geral">
            <div class="progress-bar" role="progressbar" :style="'width: ' + Math.round( (apurando_geral.parcial / apurando_geral.total ) * 100 ) + '%'"></div>
        </div>

        <div v-if="1==0 && apurados && apurados.length">

            <div class="row mb-2">
                <div class="col col-12 col-md-8">
                    <az-input 
                        icon="fa fa-search"
                        placeholder="Pesquisar"
                        v-model="search_apurados">
                        <template v-slot:buttonposb>
                            <print-export 
                                printid="impressao-lista"
                                :data="exibicao_apurados" 
                                :fields="['medico.search', 'valor_repasse']" 
                                filename="apuracao" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-4">
                    <az-input 
                        type="checkbox-group"
                        label="Exibir zerados"
                        v-model="exibir_zerados" />
                </div>
            </div>

            <div id="impressao-lista">

                <div class="card">

                    <div class="card-header d-print-none" v-if="primeiro">

                        <div>
                            <div class="d-flex justify-content-between">
                                <div v-if="primeiro.parms.origem == 'P'">
                                    Produção
                                </div>
                                <div v-if="primeiro.parms">
                                    {{ $util.getFormatDate(primeiro.parms.inicio) }} a {{ $util.getFormatDate(primeiro.parms.fim) }}
                                </div>
                            </div>
                            <template v-if="primeiro.parms.filtros && primeiro.parms.filtros.length">
                                <hr>
                                <div v-for="(filtro, ifx) in primeiro.parms.filtros" :key="ifx">
                                    <span v-if="filtro.model">
                                        <i class="fa fa-plus-circle fa-fw mr-2" aria-hidden="true" v-if="filtro.fl_regra"></i>
                                        <i class="fa fa-minus-circle fa-fw mr-2" aria-hidden="true" v-else></i>
                                        {{ titulo_model(filtro) }}
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ filtro.model.search }}
                                    </span>
                                </div>
                            </template>
                        </div>

                    </div>

                    <table class="table table-hover table-sm mb-0">
                        <thead>
                            <tr>
                                <th>Profissional</th>
                                <th class="text-right">Produção</th>
                                <th class="text-right">Repasse</th>
                                <th class="text-right">Clínica</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(apurado, iax) in exibicao_apurados">
                                <tr :key="iax" v-show="exibir_zerados || apurado.valor_repasse">
                                    <td>
                                        {{ apurado.medico.search }}
                                    </td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(apurado.valor_producao) }}
                                    </td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(apurado.valor_repasse) }}
                                    </td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(apurado.valor_clinica) }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>Total</th>
                                <th class="text-right">{{ $util.formatMoeda(total_apurado.producao) }}</th>
                                <th class="text-right">{{ $util.formatMoeda(total_apurado.repasse) }}</th>
                                <th class="text-right">{{ $util.formatMoeda(total_apurado.clinica) }}</th>
                            </tr>
                        </tfoot>
                    </table>

                </div>

            </div>

        </div>

        <repasse-apuracao 
            ref="apuracao"
            :id_medico="medico ? medico.id_pessoa : null" 
            :origem="origem" 
            :simulacao="true"
            :callback_apuracao="apurando_geral !== false ? step_apuracao : null" /> 

        <br><br><br><br><br>

        <!-- Modal de Atendimentos -->
        <div class="modal fade" id="atendimentosRepasseModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Atendimentos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-3">
                                <az-input  
                                    type="date"
                                    label="Data"
                                    v-model="atend.data">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-primary" type="button" id="button-addon1"
                                                @click="buscar_medicos()"
                                                :disabled="$store.state.loading">
                                                <i class="fas fa-sync-alt fa-fw"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-9">
                                <az-input
                                    type="select"
                                    label="Unidade"
                                    placeholder="Todas..."
                                    :optionsList="$util.unidades_com_tags(false, true)" 
                                    optionsData="id_unidade_operacao"
                                    v-model="atend.id_unidade_operacao" />
                            </div>
                        </div>

                        <az-empty-state
                            class="mt-3"
                            icon="fa fa-user-md"
                            :msg="medicos === null ? 'Buscar Profissionais...' : 'Nenhum profissional identificado.'"
                            v-if="!medicos || !medicos.lista.length" />

                        <div v-else>
                            <div class="progress mt-1 mb-3">
                                <div class="indeterminate" v-if="$store.state.loading"></div>
                                <div class="determinate" v-else></div>
                            </div>

                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    {{ $util.getFormatDate(medicos.parms.data) }}
                                </div>
                                <div v-if='medicos.unidade'>
                                    {{ medicos.unidade.st_nome }}
                                </div>
                            </div>

                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" v-for="(medico, imx) in medicos.lista" :key="imx"
                                    @click="selecionar_medico(medico)">
                                    {{ medico.medico.st_nome_exibicao }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <medico-lista 
            ref="ml" 
            :para_selecionar="true"
            @selecionar="selecionar_medicos" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import RepasseApuracao from './RepasseApuracao.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import MedicoLista from '../../shared/MedicoLista.vue';
import PrintExport from '../../shared/PrintExport.vue';

export default {
    data() { 
        return { 
            medico: "", 
            origem: "", 
            tipo_quebra: "N", 
            atend: { 
                data: this.$util.hoje(),
                id_unidade_operacao: "", 
            },
            medicos: null, 
            lista_apuracao: [], 
            apurados: [], 
            apurando_geral: false, 
            exibir_zerados: false, 
            search_apurados: "", 
        };
    },

    components: { 
        AzInput, 
        RepasseApuracao, 
        AzEmptyState,
        MedicoLista, 
        PrintExport, 
    },

    computed: { 
        total_apurado: function() { 
            return { 
                producao: _.sumBy(this.apurados, 'valor_producao'),
                repasse: _.sumBy(this.apurados, 'valor_repasse'),
                clinica: _.sumBy(this.apurados, 'valor_clinica')
            };
        },

        primeiro: function () { 
            return _.first(this.apurados);
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\formaPagamento', search:'Forma de Pagamento', service: 'forma_pagamentos.index', nosync: true},
                // {id:'App\\azure\\fatura', search:'Fatura', service: 'faturas.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'});
            }
            
            return opcoes;
        },

        exibicao_apurados: function () { 
            let reg = this.$util.getregex(this.search_apurados);
                
            return this.apurados.filter(item => !this.search_apurados || reg.test(JSON.stringify(item)));
        }
    },

    methods: { 
        titulo_model (filtro) { 
            let model = this.lista_opcoes_filtro.find(op => op.id == filtro.model_type);
            return model ? model.search : '?';
        },

        apurar_geral () { 
            this.$refs.ml.abrir('medico', null);
        },

        step_apuracao (retorno) { 

            /*

            if ( retorno && retorno.apuracao.length ) { 
                console.log(retorno);
            }

            retorno.valor_producao = _.sumBy(retorno.apuracao, 'valor_base');
            retorno.valor_repasse = _.sumBy(retorno.apuracao, 'valor_base_rateio');
            retorno.valor_clinica = _.sumBy(retorno.apuracao, 'valor_clinica');

            */
            
            this.apurados.push(retorno);

            this.apurando_geral.parcial ++; 

            if ( this.lista_apuracao.length ) { 
                this.medico = _.first(this.lista_apuracao);

                this.lista_apuracao.splice(0,1);

                this.$nextTick(() => { 
                    this.$refs.apuracao.buscar_apuracao(true);
                });
            } else { 
                this.apurando_geral = false;
                this.medico = "";

                this.$toast.add({ 
                    severity: 'success', 
                    summary: 'Atenção', 
                    detail: 'Apuração concluída.',
                    life: 3000, 
                });
            }
        },

        selecionar_medicos (lista) { 
            if ( !lista.length )  { 
                this.$toast.add({ 
                    severity: 'warn', 
                    summary: 'Atenção', 
                    detail: 'Nenhum profissional selecionado.',
                    life: 3000, 
                });
                return;
            }

            $('.modal').modal('hide');

            this.apurados = [];

            this.apurando_geral = { 
                total: lista.length,
                parcial: 0, 
            };

            this.lista_apuracao = _.cloneDeep(lista);

            this.medico = _.first(this.lista_apuracao);

            this.lista_apuracao.splice(0,1);

            this.$refs.apuracao.selecionar_apuracao();

            // this.mult = true; 
            //console.log(lista);
            //this.$refs.apuracao.selecionar_apuracao();
        }, 

        buscar_apuracao () { 
            if ( !this.medico ) { 
                this.apurar_geral();
                return;
            }

            this.$refs.apuracao.selecionar_apuracao();
        },

        selecionar_medico(medico) { 
            $('#atendimentosRepasseModal').modal('hide');

            this.medico = "";

            this.$nextTick(() => { 

                let lista = this.$store.state.options['medicos-cadastro'];

                if ( lista ) { 
                    let item = lista.find(item => item.id_pessoa == medico.id_medico);

                    if ( item ) { 
                        this.medico = item;
                    }
                }

            });
        },

        verificar_atendimentos () { 
            $('#atendimentosRepasseModal').modal('show');
        },

        buscar_medicos() { 
            this.$util.load(this, { 
                service: 'repasses',
                func: 'buscar_atendimentos',
                parms: this.atend, 
                loadTo: res => { 
                    this.medicos = res;
                }
            });
        }
    },

    beforeMount() { 
        this.origem = this.$util.getCookie('rp-apr-origem') == 'P' ? 'P' : '';
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Repasse", path: "" },
            { name: "Apuração", path: "/repasse/apuracao" }
        ]);
    }
    
}
</script>